export const images = {
  // public image
  noImage: '/images/noImage.png',
  icUpload: '/images/icUpload.png',
  icCamera: '/images/icCamera.png',
};
